const { sorter } = require('../src/common');
const {
  fetchUSSchools,
  fetchCASchools
} = require('./fetch_school');

// Escape values before building HTML with .append() (CJ2 hardening). The dropdown /
// school-search data is from static bundled datasets today; escape at the sink so a
// future runtime source for these can't inject markup.
const esc = s => String(s == null ? '' : s)
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

async function checkBetaCode({
  code
}) {
  const response = await fetch('/users/register/validate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      code
    })
  });

  if (response.ok) {
    return;
  }

  throw await response.json();
}

/**
 * returned a list of countries with US and CA appearing first
 * @return {Array<Array<string>>}
 */
function getCountries() {
  return Object.entries(require('iso-3166-1-alpha-2').getData())
    .filter(c => !['AS', 'GU', 'MP', 'PR', 'VI'].includes(c[0]))
    .sort((a, b) => {
      if (a[0] == b[0])
        return 0;
      if (a[0] == 'US')
        return -1;
      if (b[0] == 'US')
        return 1;
      if (a[0] == 'CA')
        return -1;
      if (b[0] == 'CA')
        return 1;
      return sorter(d => d[1])(a, b);
    });
}

/**
* @param {string} id 
* @param {Array<Array<string>>} options format: [[value, title], [value, title], ...] 
*/
function updateDropdown(id, options) {
  $(`#${id} option`).remove(':not([disabled])');
  $(`#${id} option[disabled]`).prop('selected', true);
  $(`#${id}`).append(options.map(r => `<option value="${esc(r[0])}">${esc(r[1])}</option>`));
}

async function updateStates(code) {
  updateDropdown('school-state',
    Object.entries((await import('iso-3166-2')).country(code).sub)
      .map(r => [r[0].slice(3), r[1].name])
      .filter(r => r[0] != 'UM')
      .sort(sorter(r => r[1])));
}

function show(selector, on) {
  if (on) {
    $(`${selector}-group`).removeClass('d-none');
  } else {
    $(`${selector}-group`).addClass('d-none');
  }
}

function resetSearch() {
  $('#school-search').prop('readonly', false);
  $('#school-search-group button').addClass('d-none');
  $('#school-search-group label').text('Search for your school by full name:');
  $('#school-id').val('');
}

function showSchoolSearch(on) {
  show('#school-search', on);
  $('#school-id').attr('required', on);
  if (on)
    $('#school-name').val('');
  else {
    $('#school-options').addClass('d-none');
    // clear error from search, otherwise submit will fail
    $('#school-search').each((_, el) => el.setCustomValidity(''));
    resetSearch();
  }
}

function required(selector, on) {
  show(selector, on);
  if (on) {
    $(selector).attr('required', true);
  } else {
    $(selector).attr('required', false).val('');
    $(`${selector} option[disabled]`).prop('selected', true);
  }
}

function setFieldsBasedOnRole(role) {
  if (role === null)
    return;
  required('#school-country', role != 'other');
  if (role == 'other') {
    // hide fields that has been shown already
    required('#school-state', false);
    required('#school-city', false);
    required('#school-name', false);
    required('#school-type', false);
    showSchoolSearch(false);
  }
}

async function setFieldsBasedOnCountry(country) {
  if (country == 'US' || country == 'CA') {
    $('#school-state-group label').text(country == 'US' ? "Your state:" : "Your province:");
    required('#school-state', true);
    required('#school-name', false);
    required('#school-type', false);
    await updateStates(country);
  } else {
    required('#school-state', false);
    required('#school-name', true);
    required('#school-type', true);
  }
  required('#school-city', false);
  showSchoolSearch(false);
}

async function setFieldsBasedOnState(state) {
  const country = $('#school-country').val();
  required('#school-city', true);
  const cities = (await (country == 'US' ? import('us-cities') : import('ca-cities')))
    .list.filter(city => city.state == state);
  updateDropdown('school-city', cities.map(city => [city.name.replace(/ /g, '_'), city.name]));
  showSchoolSearch(false);
}

async function setFieldsBasedOnCity() {
  resetSearch();
  showSchoolSearch(true);
  if (!await searchAndDisplaySchools())
    $('#school-search').trigger('focus');
  required('#school-name', false);
  required('#school-type', false);
}

async function fetchSchools(country, text, filters) {
  if (country == 'US')
    return await fetchUSSchools(text, filters);
  if (country == 'CA')
    return await fetchCASchools(text, filters);
  throw new Error(`Search for country ${country} not implemented!`);
}

let searchInProgress = false;

/**
 * @return {Promise<boolean>} results shown 
 */
async function searchAndDisplaySchools() {
  const text = $('#school-search').val();
  if (searchInProgress)
    return false;
  searchInProgress = true;
  const response = await fetchSchools($('#school-country').val(), text, {
    state: $('#school-state').val(),
    city: $('#school-city').val().replace(/_/g, ' ')
  });
  searchInProgress = false;
  if (text != $('#school-search').val())
    return await searchAndDisplaySchools();

  if (response.total_count > 10) {
    $('#school-options').addClass('d-none');
    return false;
  }
  $('#school-options .list-group').empty()
    .append(response.results.map(school =>
      `<button type="button" class="list-group-item list-group-item-action list-group-item-primary select-school-button" id="${esc(school.source + ':' + school.state + ':' + (school.objectid || school.id))}">${esc(school.name)}</button>`))
    .append(`<button type="button" class="list-group-item list-group-item-action list-group-item-warning select-school-button" id='new'>My school is not listed</button>`);
  $('#school-options').removeClass('d-none');
  $('.select-school-button').on('click', e => {
    if (e.target.id == 'new') {
      showSchoolSearch(false);
      required('#school-name', true);
      required('#school-type', true);
      $('#school-id').val('');
      $('#school-name').trigger('focus');
    } else {
      $('#school-search').val(e.target.textContent).prop('readonly', true);
      $('#school-search-group button').removeClass('d-none');
      $('#school-search-group label').text('Selected school:');
      $('#school-id').val(e.target.id);
      $('#school-options').addClass('d-none');
    }
  });
  return true;
}

async function initializeFields() {
  setFieldsBasedOnRole($('#user-role').val());
  if (window.school_country) {
    $('#school-country').val(window.school_country);
    await setFieldsBasedOnCountry(window.school_country);
  } else if ($('#school-country').val()) // handle browser selecting country
    await setFieldsBasedOnCountry($('#school-country').val());
  if (window.school_state) {
    $('#school-state').val(window.school_state);
    await setFieldsBasedOnState(window.school_state);
  }
  if (window.school_city) {
    $('#school-city').val(window.school_city);
    setFieldsBasedOnCity();
  }
  if (window.school_type)
    $('#school-type').val(window.school_type);
}

$(window).on('pageshow', initializeFields);

$(() => {
  $('#useragent').val(navigator.userAgent || 'unknown');
  if ($('#school-country')) {
    $('#school-country').append(getCountries().map(
      ([code, name]) => `<option value=${code}>${name}</option>`));
  }
  initializeFields();

  $('#user-role').on('change', e => setFieldsBasedOnRole(e.target.value));

  $('#school-country').on('change', e => setFieldsBasedOnCountry(e.target.value));

  $('#school-state').on('change', e => setFieldsBasedOnState(e.target.value));

  $('#school-city').on('change', () => setFieldsBasedOnCity());

  $('#school-search').on('input', async e => {
    $('#school-search')[0].setCustomValidity('');
    await searchAndDisplaySchools();
  });

  $('#school-search-group button').on('click', () => {
    $('#school-search').val('').prop('readonly', false);
    $('#school-search-group button').addClass('d-none');
    $('#school-search-group label').text('Search for your school by full name:');
  });

  $('#register').on('submit', async e => {
    if ($('#school-id').attr('required') && !$('#school-id').val()) {
      e.preventDefault();
      $('#school-search')[0].setCustomValidity($('#school-options').hasClass('d-none') ? "Please type more letters to display search results" : "Please select your school below or click on 'My school is not listed'.");
      e.target.reportValidity();
      return;
    }
    try {
      if ($('#subscription-code').val()) {
        e.preventDefault();
        await checkBetaCode({
          code: $('#subscription-code').val()
        });
        e.target.submit();
      }
    } catch (err) {
      console.error(err);
      if (err.error) {
        $('#subscription-code')[0].setCustomValidity(err.error);
        e.target.reportValidity();
        return;
      }
    }
    // disable inputs and submit
    $('input').prop('readonly', true);
    $('select').attr('readonly', true);
    $('#register button[type="submit"]').prop('disabled', true);
  });

  $('#subscription-code').on('input', () => {
    $('#subscription-code')[0].setCustomValidity('');;
  });

  function checkPasswordMatch() {
    const p2 = $('#password2')[0];
    if (!p2)
      return;
    const password = $('#password').val();
    const password2 = p2.value;
    p2.setCustomValidity(password2 && password !== password2 ? "Passwords do not match" : '');
  }
  $('#password, #password2').on('input', checkPasswordMatch);
});
